// INSTANCES
import { ApiAxiosInstance } from '../instances/apiAxiosInstance';

// TYPES
import type {
  AccountExecutiveData,
  IGetAccountParams,
  VerifyLimits,
  VerifyLimitsResponse,
} from '@/types/AccountType';
import type { AccountBankType } from '@/types/AccountBankType';
import type { AccessRolType } from '@/shared/access';

export const accountClient = {
  getAccountBanks(params: IGetAccountParams) {
    return ApiAxiosInstance.get<AccountBankType[]>('customer/b2b/account', {
      params,
    });
  },

  postAccountBank(accountBank: AccountBankType) {
    return ApiAxiosInstance.post<void>('customer/b2b/account', accountBank);
  },

  updateAccountBank(accountBank: AccountBankType) {
    return ApiAxiosInstance.put<void>('customer/b2b/account', accountBank);
  },
  getAccountVerifyLimits(params: VerifyLimits) {
    return ApiAxiosInstance.get<VerifyLimitsResponse>(
      `/product-gateway/b2b/account/verify-limits`,
      {
        params,
      }
    );
  },
  emergencyBlocked() {
    return ApiAxiosInstance.post('company/b2b/account/blocked');
  },
  getAccountExecutiveData() {
    return ApiAxiosInstance.get<AccountExecutiveData>('company/b2b/executives');
  },

  getAccessRol() {
    return ApiAxiosInstance.get<AccessRolType[]>('company/b2b/user-permissions');
  },
};
